import { defineMessages } from "react-intl";

export const coachesMessages = defineMessages({
  "coaches.heading": { id: "coaches.heading", defaultMessage: "Coaches" },
  "coaches.filter.language.label": {
    id: "coaches.filter.language.label",
    defaultMessage: "Language",
  },
  "coaches.filter.field.label": {
    id: "coaches.filter.field.label",
    defaultMessage: "Field",
  },
  "coaches.filter.primaryRoles.label": {
    id: "coaches.filter.primaryRoles.label",
    defaultMessage: "Primary roles",
  },
  "coaches.filter.experience.label": {
    id: "coaches.filter.experience.label",
    defaultMessage: "Experience",
  },
  "coaches.filter.timezones.label": {
    id: "coaches.filter.timezones.label",
    defaultMessage: "Time zones",
  },
  "coaches.filter.rate.label": {
    id: "coaches.filter.rate.label",
    defaultMessage: "Rate",
  },
  "coaches.filter.rate.tooltip.credits-per-session": {
    id: "coaches.filter.rate.tooltip.credits-per-session",
    defaultMessage: "{credits} credits per session",
  },
  "coaches.filter.rate.tooltip.info": {
    id: "coaches.filter.rate.tooltip.info",
    defaultMessage: "1 credit = 1 euro",
  },

  "coaches.filter.clear-button": {
    id: "coaches.filter.clear-button",
    defaultMessage: "Remove all filters",
  },
  "coaches.filter.search.placeholder": {
    id: "coaches.filter.search.placeholder",
    defaultMessage: "Search",
  },

  "coaches.filter.favorites.label": {
    id: "coaches.filter.favorites.label",
    defaultMessage: "Favorites",
  },
  "coaches.filter.favorites.tooltip.empty": {
    id: "coaches.filter.favorites.tooltip.empty",
    defaultMessage:
      "Add some favorite coaches with {icon} icon next to coach name.{localText}",
  },

  "coaches.coach.bookmark.add": {
    id: "coaches.coach.bookmark.add",
    defaultMessage: "Add to favorites",
  },
  "coaches.coach.bookmark.remove": {
    id: "coaches.coach.bookmark.remove",
    defaultMessage: "Remove from favorites",
  },

  "coaches.coach.experience": {
    id: "coaches.coach.experience",
    defaultMessage: "Experience: {experience} years",
  },

  "coaches.coach.timezone": {
    id: "coaches.coach.timezone",
    defaultMessage: "Time zone: {timeZone}",
  },

  "coaches.coach.show-more": {
    id: "coaches.coach.show-more",
    defaultMessage: "Show more",
  },
  "coaches.coach.languages": {
    id: "coaches.coach.languages",
    defaultMessage: "Languages",
  },
  "coaches.coach.primaryRoles": {
    id: "coaches.coach.primaryRoles",
    defaultMessage: "Primary Roles",
  },
  "coaches.coach.rate": {
    id: "coaches.coach.rate",
    defaultMessage: "Rate",
  },
  "coaches.coach.contact": {
    id: "coaches.coach.contact",
    defaultMessage: "Contact",
  },
  "coaches.coach.introduction-link": {
    id: "coaches.coach.introduction-link",
    defaultMessage: "Video introduction",
  },

  "coaches.contact.title": {
    id: "coaches.contact.title",
    defaultMessage: "Contact {name}",
  },
  "coaches.contact.perex": {
    id: "coaches.contact.perex",
    defaultMessage: "Let the coach know what interests you the most.",
  },
  "coaches.contact.subject.label": {
    id: "coaches.contact.subject.label",
    defaultMessage: "Subject",
  },
  "coaches.contact.message.label": {
    id: "coaches.contact.message.label",
    defaultMessage: "Message",
  },
  "coaches.contact.message.placeholder": {
    id: "coaches.contact.message.placeholder",
    defaultMessage: "Type your message",
  },
  "coaches.contact.button.send": {
    id: "coaches.contact.button.send",
    defaultMessage: "Send",
  },
  "coaches.contact.button.cancel": {
    id: "coaches.contact.button.cancel",
    defaultMessage: "Cancel",
  },
  "coaches.contact.success": {
    id: "coaches.contact.success",
    defaultMessage:
      "Your message has been sent, coach will contact you as soon as possible",
  },

  "coaches.aside.title": {
    id: "coaches.aside.title",
    defaultMessage: "What to expect",
  },

  "coaches.aside.items.1.heading": {
    id: "coaches.aside.items.1.heading",
    defaultMessage: "€100",
  },
  "coaches.aside.items.1.text": {
    id: "coaches.aside.items.1.text",
    defaultMessage: "Fixed price of all sessions",
  },

  "coaches.aside.items.2.heading": {
    id: "coaches.aside.items.2.heading",
    defaultMessage: "Trusted specialists",
  },
  "coaches.aside.items.2.text": {
    id: "coaches.aside.items.2.text",
    defaultMessage:
      "Our handpicked team of certified (ICF and EMCC) and experienced coaches bring a wealth of knowledge and expertise to deliver measurable leadership growth and lasting impact.",
  },

  "coaches.aside.items.3.heading": {
    id: "coaches.aside.items.3.heading",
    defaultMessage: "Privacy",
  },
  "coaches.aside.items.3.text": {
    id: "coaches.aside.items.3.text",
    defaultMessage:
      "We take our responsibility to protect your data very seriously. TopLeader is an entirely in-house programmed coaching software, using only the highest industry standards to guarantee data protection and ensure privacy and confidentiality.",
  },
  "your-coach.heading": {
    id: "your-coach.heading",
    defaultMessage: "Your coach",
  },
  "your-coach.session-link-info": {
    id: "your-coach.session-link-info",
    defaultMessage:
      "Your coach will send a session link in your messages or via email. Check before your session!", // TODO: change textation in input.csv
  },
});
